import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const initialMSMEs = [
  { name: "Aarav Textiles", place: "Surat", score: 94 },
  { name: "Sarthak Engineering", place: "Pune", score: 92 },
  { name: "Unity AgroTech", place: "Nagpur", score: 90 },
  { name: "GreenWave Biotech", place: "Chandigarh", score: 89 },
  { name: "Luminous Logistics", place: "Hyderabad", score: 87 },
  { name: "NeoAuto Components", place: "Coimbatore", score: 86 },
  { name: "Precision Pipes", place: "Rajkot", score: 85 },
  { name: "Shree Foods Pvt Ltd", place: "Indore", score: 84 },
  { name: "BlueOrbit Tech", place: "Bengaluru", score: 83 },
  { name: "Crystal Chemicals", place: "Vadodara", score: 82 },
  { name: "Sunrise Plastics", place: "Aurangabad", score: 91 },
  { name: "EcoTech Solutions", place: "Jaipur", score: 88 },
  { name: "IronClad Components", place: "Jamshedpur", score: 85 },
  { name: "AquaPure Systems", place: "Bhopal", score: 83 },
  { name: "Rapid Packaging", place: "Lucknow", score: 80 },
];

const UdyamPragatiScorecard = () => {
  const { isLoggedIn, user } = useSelector((state) => state.authReducer);
  const [userName] = useState(user?.name || "Guest");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [rankings, setRankings] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const shuffleAndSelectTop10 = () => {
    const shuffled = [...initialMSMEs]
      .sort(() => 0.5 - Math.random())
      .slice(0, 10)
      .sort((a, b) => b.score - a.score)
      .map((msme, index) => ({ rank: index + 1, ...msme }));
    setRankings(shuffled);
  };

  useEffect(() => {
    shuffleAndSelectTop10();
    const interval = setInterval(shuffleAndSelectTop10, 5000);
    return () => clearInterval(interval);
  }, []);

  const today = new Date().toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div className="flex flex-col min-h-[100dvh] font-sans text-cyan-800 bg-black overflow-hidden">
      <header className="flex justify-between items-center px-4 py-1 bg-black shadow-md sticky top-0 z-50 border-b border-cyan-500">
        <div
          onClick={() => navigate("/rankings")}
          className="text-lg lg:text-xl font-bold text-yellow-200 tracking-wide cursor-pointer"
        >
          🏆 SAKSHAM MSME / Udyam Pragati Rankings
        </div>

        <div className="hidden md:flex items-center space-x-2">
          {isLoggedIn && (
            <>
              <span className="text-white font-medium">{userName}</span>
              <button
                onClick={handleLogout}
                className="w-8 h-8 mt-2 flex items-center justify-center text-lg bg-blue-500 text-white rounded-full hover:bg-blue-600 transition sm:w-9 sm:h-9"
                title="Logout"
              >
                ⏻
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden mt-2 w-8 h-8 flex items-center justify-center text-xl bg-blue-700 text-white"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>        
      </header>

      {/* MOBILE MENU */}
      {isMobileMenuOpen && (
        <nav className="md:hidden bg-blue-700 flex flex-col px-4 py-3 space-y-3">
          {isLoggedIn && (
            <div className="border-t pt-3 border-blue-500 text-white">
              <p className="mb-2 text-sm">{userName}</p>
              <button
                onClick={handleLogout}
                className="bg-blue-500 text-white mt-4 px-4 py-2 rounded text-sm hover:bg-blue-600 w-full transition"
              >
                Logout
              </button>
            </div>
          )}
        </nav>
      )}

      <main className="flex-1 bg-black text-cyan-900 p-4 overflow-y-auto">
        <div className="text-center mb-2">
          <p className="text-white font-medium">{today}</p>
        </div>

        <div className="bg-black rounded-lg shadow-md">
          <table className="min-w-full text-sm md:text-base">
            <thead className="bg-black text-white uppercase text-xs md:text-sm">
              <tr>
                <th className="py-2 px-3 border">Rank</th>
                <th className="py-2 px-4 border">MSME Name</th>
                <th className="py-2 px-4 border">Place</th>
                <th className="py-2 px-3 border">Score</th>
              </tr>
            </thead>
            <tbody>
              {rankings.map(({ rank, name, place, score }) => (
                <tr
                  key={name}
                  className="text-left hover:bg-gray-600 text-white transition-all"
                >
                  <td className="py-2 px-2 border text-white text-center">{rank}</td>
                  <td className="py-2 px-2 border text-white">{name}</td>
                  <td className="py-2 px-2 border text-white">{place}</td>
                  <td className="py-2 px-2 border text-center font-semibold text-white">
                    {score}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>

      <footer className="bg-black border-t border-blue-400 text-white py-2 px-4 mt-2">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
          <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
          <div className="flex flex-row gap-2 sm:gap-6 text-xs sm:text-sm">
            <Link to="/about-us" className="text-white hover:text-blue-200 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-blue-200 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-blue-200 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-blue-200 transition">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
};

export default UdyamPragatiScorecard;
